import React from "react"
import PropTypes from "prop-types"

import MeetingListItem from '../meeting_sections/MeetingListItem'
import LoaderSection from '../app_components/LoaderSection'

class UpcomingMeetingSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      matches: [],
      noMatches: false,
      lessThanThree: false,
      meetings: [],
      loading: true
    }
    this.renderMatch = this.renderMatch.bind(this)
    this.renderLoader = this.renderLoader.bind(this)
    this.renderMatchSection = this.renderMatchSection.bind(this)
    this.headerText = this.headerText.bind(this)
    this.renderNoMeetingSection = this.renderNoMeetingSection.bind(this)
    this.renderMeetingSection = this.renderMeetingSection.bind(this)
    this.renderSection = this.renderSection.bind(this)
    this.getAllMeetings = this.getAllMeetings.bind(this)
  }

  getAllMeetings() {
    $.ajax({
      url: `../getAllMeetings`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          meetings: JSON.parse(data.data.upcoming_meetings),
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }



  componentDidMount() {

    $.ajax({
      url: `../home_matches`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: function(data) {
        if(JSON.parse(data.data.matches).length === 0) {
          this.setState({
            matches: JSON.parse(data.data.matches),
            meetings: JSON.parse(data.data.meetings),
            loading: false,
            noMatches: true
          })
        } else if (JSON.parse(data.data.matches).length < 3) {
          this.setState({
            matches: JSON.parse(data.data.matches),
            meetings: JSON.parse(data.data.meetings),
            loading: false,
            lessThanThree: true
          })
        } else {
          this.setState({
            matches: JSON.parse(data.data.matches),
            meetings: JSON.parse(data.data.meetings),
            loading: false
          })
        }
      }.bind(this),
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });

  }

  headerText() {
    if(this.state.meeting === 'null') {
      return "Schedule your first Lex!"
    }
    return "You do not have a scheduled Lex!"
  }

  renderLoader(n) {
    return(
      <div id={`image${n}`}></div>
    )
  }

  renderMatch(n) {
      let match = this.state.matches[n]
      return (
        <div  style={{height: '25%', cursor: 'pointer'}} onClick={() => window.location.assign(`/profile/${match.slug}`)}>
          <img src={match.avatar_url}  className="home_matches_avatar_standard"/>
        </div>
      )
  }

  renderMatchSection() {
    if(this.state.loading) {
      return(
              <div className="wrapper_input" style={{width: '100%'}}>
                  <div style={{flexDirection: 'row', justifyContent: 'center', display: 'flex'}}>
                    <div>
                      {this.renderLoader(0)}
                    </div>
                    <div>
                      {this.renderLoader(1)}
                    </div>
                    <div>
                      {this.renderLoader(2)}
                    </div>
                  </div>
                </div>
      )
    }
    return(
            <div className="wrapper_input" style={{width: '100%'}}>
                <div style={{flexDirection: 'row', justifyContent: 'center', display: 'flex'}}>
                  <div >
                    {(this.state.matches[0] != undefined) ? this.renderMatch(0) : null}
                  </div>
                  <div id="" >
                    {(this.state.matches[1] != undefined) ? this.renderMatch(1) : null}
                  </div>
                  <div id="" >
                    {(this.state.matches[2] != undefined) ? this.renderMatch(2) : null}
                  </div>
                </div>
              </div>
    )
  }

  renderNoMeetingSection() {
    if(this.state.noMatches) {
      return(
        <div style={{padding: 24}}  >
          <h3 style={{fontSize: 20, paddingTop: 12}}>{this.headerText()}</h3>
          <br />
          <h4 style={{fontWeight: 100}}>Hmm... we see you have no matches.</h4>
          <h4 style={{fontWeight: 100}}>Is your profile complete?</h4>
          <h4 style={{fontWeight: 100, marginBottom: 20}}>Are your languages correct?</h4>
            <button className="btn_secondary" style={{marginBottom: 10}} onClick={() => window.location.assign(`/edit`)}>My Profile Settings</button>
            <button className="btn_secondary" style={{marginBottom: 10}} onClick={() => window.location.assign(`/my_languages`)}>My Language Settings</button>
            <br />
        </div>
      )
    } else if (this.state.lessThanThree) {
      return(
        <div style={{padding: 24}} >
          <h3 className="modalHeader" style={{fontSize: 20, paddingTop: 12}}>{this.headerText()}</h3>
          <br />
          <h4 style={{fontWeight: 100}}>Here are your matches.</h4>
          <h4 style={{fontWeight: 100}}>Click on their picture, chat, and schedule a time to meet up!</h4>
          <hr style={{borderColor: '#F48FB1', borderTopWeight: 2, maxWidth: '85%', margin: 'auto', marginTop: 12}}/>
          <hr style={{borderColor: '#F48FB1', borderTopWeight: 2, maxWidth: '85%', margin: 'auto', marginBottom: 24}}/>
          {this.renderMatchSection()}
          <h4 style={{fontWeight: 100, marginTop: 50}}>Hmm... we see you do not have many matches.</h4>
          <h4 style={{fontWeight: 100}}>Is your profile complete?</h4>
          <h4 style={{fontWeight: 100, marginBottom: 20}}>Are your languages correct?</h4>
            <button className="btn_secondary" onClick={() => window.location.assign(`/edit`)}>My Profile Settings</button>
            <button className="btn_secondary" onClick={() => window.location.assign(`/my_languages`)}>My Language Settings</button>
            <br /> <br />
        </div>
      )
    }
    return(
      <div style={{ padding: 24}}  >
        <h3 style={{fontSize: 20}}>{this.headerText()}</h3>
        <br />
        <h4 style={{fontWeight: 100}}>Here are 3 matches.</h4>
        <h4 style={{fontWeight: 100}}>Click on their picture, chat, and schedule a time to meet up!</h4>
        <hr style={{borderColor: '#F48FB1', borderTopWeight: 2, maxWidth: '85%', margin: 'auto', marginTop: 12}}/>
        <hr style={{borderColor: '#F48FB1', borderTopWeight: 2, maxWidth: '85%', margin: 'auto', marginBottom: 24}}/>
        {this.renderMatchSection()}
        <div style={{height: 30}}>
          <button className='small_button_secondary' style={{float: 'right', marginTop: 20, marginBottom: 20}} onClick={() => window.location.assign(`/friends`)}>See All My Language Matches</button>
        </div>
      </div>
    )
  }

  renderMeetingSection() {
    return this.state.meetings.map((meeting, i) => {
      return(
        <div key={i} style={{textAlign: 'left'}}>
          <MeetingListItem
            item={meeting}
            currentUser={this.props.currentUser}
            getAllMeetings={this.getAllMeetings}
            />

        </div>
      )
    })
  }

  renderSection() {
    if (this.state.loading === true) {
      return <LoaderSection />
    } else if (this.state.meetings.length > 0) {
      return this.renderMeetingSection()
    }
    return this.renderNoMeetingSection()
  }

  render() {
    return(
        <div className="matches_wrapper">
          <div className="match-profile-container">
            <div className="profile_heading" className="darkBlue">
                <h4 className="sectionHeader" style={{textAlign: 'left'}}>Your Upcoming Lexes</h4>
                {this.renderSection()}
            </div>
          </div>
        </div>
    )
  }
}

export default UpcomingMeetingSection;
